import { CallProviderType } from '@gem/call/Model/callModel.types';
import { initCallsApi } from '@gem/call/WsApi/wsCallsApi/WsCallsApi';
import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { AudioSourceType } from 'APP/constants/app';
import { ProjectUrls } from 'APP/packages/projectUrls/ProjectUrls';
import Entities from 'STORE';
import { MainCall } from 'STORE/Calls/MainCall/MainCall';

interface IJoinToCallData {
  groupId?: string | null;

  channelId: string;
  withAudio: boolean;
  withVideo: boolean;
  providerType: CallProviderType;
}

export const joinToCall = async ({
  groupId,
  channelId,
  withAudio,
  withVideo,
  providerType,
}: IJoinToCallData): Promise<void> => {
  initCallsApi(ProjectUrls.wsCallsUrl);

  if (Entities.Calls.ongoingCall || Entities.ActiveStream.hasStream) {
    Tasks.app.showAlert(t('calls_join_another_call'));

    return;
  }

  const group = groupId ? Entities.GroupsStore.getGroupById(groupId) : null;
  const call = new MainCall({
    myId: Entities.usersStore.Me.id,
    calls: Entities.Calls,
    groupId: groupId || undefined,
    channelId,
    providerType,
    withoutTimer: channelId ? true : !group?.isP2P,
    initialMedia: {
      withAudio,
      withVideo,
    },
    initialDevicesIds: {
      audiooutput: null,
      audioinput: null,
      videoinput: null,
    },
  });

  Entities.Calls.add(call);
  Entities.IncomingCalls.delete(channelId, groupId);

  const hasPermissions = await Tasks.permissions.hasAudioPermissions(!!group?.isP2P);

  if (!hasPermissions) {
    Tasks.calls.decline({
      groupId,
      channelId,
    });

    Entities.Calls.delete(call.groupId, call.channelId);
    return;
  }

  Tasks.app.audioSource.setCurrentSource(AudioSourceType.Call);

  await Tasks.calls.startCall({
    groupId: groupId || undefined,
    channelId,
    withAudio,
    withVideo,
  });
};
